import { cn } from "@/utils";
import { Chip, ChipProps } from "@heroui/react";
import { Check, Circle, CreditCard, Undo2, X } from "lucide-react";

export const StatusBadge = ({
  payment,
}: {
  payment: {
    status: string | null;
  };
}) => {
  const {
    color,
    icon,
  }: {
    color: ChipProps["color"];
    icon: React.ReactNode;
  } = (() => {
    switch (payment.status) {
      case "succeeded":
        return {
          color: "success",
          icon: <Check size={16} />,
        };
      case "canceled":
        return {
          color: "danger",
          icon: <X size={16} />,
        };
      case "requires_payment_method":
        return {
          color: "warning",
          icon: <CreditCard size={16} />,
        };
      case "refunded":
        return {
          color: "default",
          icon: <Undo2 size={16} />,
        };
      default:
        return {
          color: "default",
          icon: <Circle size={16} />,
        };
    }
  })();

  return (
    <Chip
      size="sm"
      color={color}
      variant="flat"
      startContent={icon}
      className={cn({
        "bg-blue-500 text-foreground-50": payment.status === "refunded",
      })}
    >
      {getStatusLabel(payment.status)}
    </Chip>
  );
};

const getStatusLabel = (status?: string | null) => {
  if (!status) return "Neznano";

  switch (status) {
    case "succeeded":
      return "Uspešno";
    case "failed":
      return "Neuspešno";
    case "processing":
    case "requires_payment_method":
      return "V obdelavi";
    case "refunded":
      return "Povrnjeno";
    case "canceled":
      return "Preklicano";
    default:
      return status;
  }
};
